import {IntermediatePart} from "../../intermediatePart";
import {LayoutAbbreviation} from "../../constants";

export default class PonyWallGlass extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'pony_wall_glass';
    this.isPonyWallPart = true;
    this.visible = true;
    this.partName = 'Pony Wall Glass';
    this.translateId = "visualizer.bathroom.shower.pony_wall_glass";
    this.isStoneFeature = false;
    this.disableOnHomeSections = true;
    this.layerPriority = 10;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new PonyWallGlass());
  }

  setZIndex(zIndexes) {
    const zIndex = zIndexes.Shower.PonyWallGlass;
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndex;
    }
    if (zIndexes && this.placeholderFeature) {
      this.placeholderFeature.layer.zIndex = zIndex;
    }
  }

  setLayers(layout) {

    const showerParent = this.getParent().getActiveShowerGroup();
    if (showerParent.showerDimensions() !== "Pony") {
      super.hideLayers();
      return;
    }

    const layoutAbr = layout.getCurrentLayoutAbbreviation();
    const matchesByBindings = this.activeFeature && this.activeFeature.dbFeature.s3Bindings.some(binding => {
      return binding.layout === LayoutAbbreviation.All || binding.layout === layoutAbr
    });

    if (matchesByBindings && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
        || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }

    this.setDefault();
    return super.setLayers(layout);
  }

  // getArrayOfConditions() {
  //   const showerParent = this.getParent();
  //   const layout = showerParent.layout;
  //   const layoutAbr = layout.getCurrentLayoutAbbreviation();
  //
  //   if (layoutAbr === LayoutAbbreviation.Small) {
  //     const showerComboParent = this.getParent().layout.parts[ShowerTubCombo.id];
  //     let showerSize = showerComboParent.showerTubComboIsActive
  //       ? showerComboParent.showerSize()
  //       : showerParent.showerSize();
  //     return [{
  //       propName: 'Size',
  //       propValue: showerSize
  //     }]
  //   }
  //
  //   return []
  // }

  setDefault() {
    const filteredFeatures = this.features.filter(f => f.matchesMetaForArrayOfConditions(this.getArrayOfConditions()));
    if (!super.tryToSetTheSameFeature(filteredFeatures)) {
      const hardCodedDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("Standard Pony Wall");
      });
      const placeholderDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("laceholder");
      });
      this.activeFeature = hardCodedDefault || filteredFeatures[0];
      this.placeholderFeature = placeholderDefault || null;
    }
  }

}
